import React from 'react'

import EditStaffForm from '../../modules/Staff/components/EditStaffForm'
export default function EditStaffPage() {
  return <EditStaffForm />
}
